export function HyrinWordmark() {
  return (
    <span className="font-heading text-[18px] font-black tracking-tight text-foreground">
      hyrin<span className="text-primary">.</span>
    </span>
  )
}
